import { render, staticRenderFns } from "./ExtAstaSxPreview.vue?vue&type=template&id=9fe1a35a&"
import script from "./ExtAstaSxPreview.vue?vue&type=script&lang=js&"
export * from "./ExtAstaSxPreview.vue?vue&type=script&lang=js&"
import style0 from "./ExtAstaSxPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports